import { createAction } from "redux-actions";

export const handleLoginSubmit = createAction("HANDLE_LOGIN_SUBMIT");
export const handleUnauthorize = createAction("HANDLE_UNAUTHORIZE");

export const handleAuthSuccess = createAction("HANDLE_AUTH_SUCCESS");
export const handleAuthError = createAction("HANDLE_AUTH_ERROR");
